import { Directive, Injectable, Input } from '@angular/core';
import { docData, Firestore } from '@angular/fire/firestore';
import { doc } from 'firebase/firestore';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { CrashlyticsService } from '../../../shared/services/crashlytics/crashlytics.service';
import { GTMEventsCrash } from './../../../shared/enums/Crashlytics';
import { ProgramClose } from './../../../shared/models/ProgramClose';
import { FirebaseService } from './../../../shared/services/firebase.service';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class ProgramClosureService {

  @Input() closeProgram: ProgramClose = {} as ProgramClose;

  private firestore: Firestore;

  constructor(
    private crashlytics: CrashlyticsService
    , private firebaseS: FirebaseService
  ) {
    this.firestore = this.firebaseS.firestore as Firestore;
  }

  /**
   * Obtiene los datos de configuracion del cierre de programa desde FireStone
   */
  public getRemoteConfigFireStone = (programa: number): Observable<any> => {
    const ref = doc(this.firestore, `configuraciones/Programa${programa}`);
    return docData(ref)
      .pipe(
        catchError(error => {
          this.crashlytics.sendCrashPlatform(GTMEventsCrash.ProgramCloseCollect, error).then(() => { });
          return of({ Activo: true });
        })
      );
  }

}
